export default __webpack_public_path__ + "static/media/GNP-color.5139083c.svg";